export interface Stat {
  value: number;
  suffix: string;
  label: string;
}

export const stats: Stat[] = [
  { value: 90, suffix: '+', label: 'Years of heritage in Nigerian business' },
  { value: 500, suffix: '+', label: 'Projects delivered across Nigeria' },
  { value: 24, suffix: '/7', label: 'Service & maintenance support' },
  { value: 12, suffix: '+', label: 'States served nationwide' },
];

export interface Division {
  name: string;
  slug: string;
  summary: string;
  icon: string;
  image: string;
}

export const divisions: Division[] = [
  {
    name: 'Power Generation & Generators',
    slug: 'power-generation',
    summary: 'Sales, installation, and round-the-clock servicing of generators and power systems for homes, businesses and industry.',
    icon: 'ri-flashlight-line',
    image: `${import.meta.env.BASE_URL}images/afb6ac41de6c3dcf.webp`,
  },
  {
    name: 'Fire Safety & Firefighting Solutions',
    slug: 'fire-safety',
    summary: 'Certified fire detection, suppression and firefighting systems designed to protect people, property and operations.',
    icon: 'ri-fire-line',
    image: `${import.meta.env.BASE_URL}images/6da781b727a5341f.webp`,
  },
  {
    name: 'Engineering & Technical Services',
    slug: 'engineering-services',
    summary: 'End-to-end engineering, installation and maintenance services supporting industries, institutions and infrastructure.',
    icon: 'ri-tools-line',
    image: `${import.meta.env.BASE_URL}images/5dd5394b6929a2d4.jpg`,
  },
  {
    name: 'Trading & Distribution',
    slug: 'trading-distribution',
    summary: 'A trusted distribution network bringing quality equipment and verified brands to businesses across Nigeria.',
    icon: 'ri-ship-2-line',
    image: `${import.meta.env.BASE_URL}images/18fae3f7c0033a93.jpg`,
  },
];

export interface Project {
  name: string;
  category: string;
  location: string;
  image: string;
}

export const featuredProjects: Project[] = [
  {
    name: 'Industrial Power Backup Installation',
    category: 'Power Generation',
    location: 'Lagos, Nigeria',
    image: `${import.meta.env.BASE_URL}images/684eb47678b0e5b7.jpg`,
  },
  {
    name: 'Commercial Fire Safety Upgrade',
    category: 'Fire Safety',
    location: 'Port Harcourt, Nigeria',
    image: `${import.meta.env.BASE_URL}images/5b0664f5205430b5.jpg`,
  },
  {
    name: 'Manufacturing Plant Technical Support',
    category: 'Engineering Services',
    location: 'Abuja, Nigeria',
    image: `${import.meta.env.BASE_URL}images/aec212a1e2f2fe39.jpg`,
  },
];

export interface Reason {
  title: string;
  description: string;
  icon: string;
}

export const reasons: Reason[] = [
  {
    title: 'Decades of Proven Heritage',
    description: 'A long-standing Nigerian institution trusted by businesses, institutions and industries nationwide.',
    icon: 'ri-award-line',
  },
  {
    title: 'Certified Technical Expertise',
    description: 'Qualified engineers and technicians delivering solutions that meet international standards.',
    icon: 'ri-shield-check-line',
  },
  {
    title: 'Nationwide Service Network',
    description: 'Responsive sales, installation and after-sales support across multiple regions.',
    icon: 'ri-map-pin-line',
  },
  {
    title: 'End-to-End Reliability',
    description: 'From consultation to installation and maintenance, we stand behind every solution we deliver.',
    icon: 'ri-customer-service-2-line',
  },
];

export interface Testimonial {
  name: string;
  role: string;
  company: string;
  quote: string;
  avatar: string;
}

export const testimonials: Testimonial[] = [
  {
    name: 'Adaeze Okafor',
    role: 'Facilities Manager',
    company: 'Lagos Business Complex',
    quote: 'John Holt PLC installed our backup power system and the service since has been outstanding — responsive, professional and reliable.',
    avatar: `${import.meta.env.BASE_URL}images/fdca4f544dbb8acf.jpg`,
  },
  {
    name: 'Chuka Nwosu',
    role: 'Operations Director',
    company: 'Industrial Group Nigeria',
    quote: 'Their engineering team understood our technical requirements immediately and delivered a solution that has run flawlessly.',
    avatar: `${import.meta.env.BASE_URL}images/fdca4f544dbb8acf.jpg`,
  },
  {
    name: 'Funmilayo Bakare',
    role: 'Compliance Lead',
    company: 'Retail Holdings',
    quote: 'The fire safety audit and installation gave our leadership real peace of mind. Thorough, certified, and well documented.',
    avatar: `${import.meta.env.BASE_URL}images/fdca4f544dbb8acf.jpg`,
  },
];

export interface NewsItem {
  title: string;
  slug: string;
  date: string;
  category: string;
  excerpt: string;
  image: string;
}

export const newsItems: NewsItem[] = [
  {
    title: 'John Holt PLC Expands Generator Service Network',
    slug: 'generator-service-network-expansion',
    date: '2026-08-12',
    category: 'Company News',
    excerpt: 'New regional service hubs aim to deliver faster response times for maintenance and emergency repairs.',
    image: `${import.meta.env.BASE_URL}images/9f468a485fe5a094.jpg`,
  },
  {
    title: 'Understanding Fire Safety Compliance for Nigerian Businesses',
    slug: 'fire-safety-compliance-guide',
    date: '2026-07-02',
    category: 'Insights',
    excerpt: 'A practical overview of fire safety standards every facility manager should know.',
    image: `${import.meta.env.BASE_URL}images/5b0664f5205430b5.jpg`,
  },
  {
    title: 'Powering Industry: Choosing the Right Generator Capacity',
    slug: 'choosing-generator-capacity',
    date: '2026-05-21',
    category: 'Insights',
    excerpt: 'Key factors to consider when sizing power backup systems for commercial and industrial use.',
    image: `${import.meta.env.BASE_URL}images/9ba7b5c1fedd8b7e.jpg`,
  },
];

export const clientLogos: string[] = [];